module.exports = __webpack_public_path__ + "media/goforajourney/img/marrakech-card-7ac1de405f6384e8e3c89548930a4aca.jpeg";